import { Box } from '@mui/material';

import { notSelectedImg, sxNotSelectedContainer } from './styles';

const NotSelectedView = () => (
  <Box sx={sxNotSelectedContainer}>
    <Box component="img" src="/assets/icons/empty/ic_email_disabled.svg" style={notSelectedImg} />
  </Box>
);

export default NotSelectedView;
